import axios from "axios";
import { _throw } from "../utils/error-service";
import { API } from '../constants/system';

/**
 * Submits a support message. Replaces the third-party chat widget: the
 * backend persists it and forwards it to Slack.
 */
export const api_send_support_message = async (message, token) => {
  try {
    const res = await axios.post(`${API}/support-messages`,
      { message, source: 'CMS' },
      {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }
    );
    return res;
  } catch (err) {
    console.error('Error sending support message:', err);
    return _throw(err);
  }
};

/** The signed-in user's own submitted messages. */
export const api_get_my_support_messages = async (token) => {
  try {
    const res = await axios.get(`${API}/support-messages`, {
      headers: { 'Authorization': token }
    });
    return res;
  } catch (err) {
    console.error('Error fetching support messages:', err);
    return _throw(err);
  }
};

/** Admin/support: all messages across users, optionally filtered. */
export const api_get_support_messages_cms = async (token, params = {}) => {
  try {
    const res = await axios.get(`${API}/cms/support-messages`, {
      headers: { 'Authorization': token },
      params
    });
    return res;
  } catch (err) {
    console.error('Error fetching CMS support messages:', err);
    return _throw(err);
  }
};

/** Admin/support: mark a message handled. */
export const api_update_support_message = async (supportMessageId, status, token) => {
  try {
    const res = await axios.put(`${API}/cms/support-messages/${supportMessageId}`,
      { status },
      {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }
    );
    return res;
  } catch (err) {
    console.error(`Error updating support message ${supportMessageId}:`, err);
    return _throw(err);
  }
};
